import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import CountDown from 'components/participates/countDown';
import { useParams } from 'react-router-dom';
import { changeOfferAgain, resetOffer } from 'slices/offerSlice';
import ItemPeopleOffer from './ItemPeopleOffer';
import successOffer from '../../assets/success-offer.svg';

const ItemSuccess = () => {
  const dispatch = useDispatch();
  const { offers, closeDate, serverDate } = useSelector((state) => state.detail.detail);
  const { mail, offer } = useSelector((state) => state.offer.offer.offer);
  const { auctionId, allOffers } = useSelector((state) => state.offersSocket.offersSock);

  const handleOfferAgain = () => {
    dispatch(resetOffer());
    dispatch(changeOfferAgain());
  };

  const [selected, setSelected] = useState(true);
  const handleToogle = () => {
    setSelected(!selected);
  };

  const scrollEvent = () => {
    document.addEventListener('scroll', () => {
      const element = document.querySelectorAll('.sticky-resumen-mobile')[0];
      if (element !== undefined) {
        if (window.scrollY <= 110) {
          element.classList.remove('active');
        } else {
          element.classList.add('active');
        }
      }
    });
  };
  const { id } = useParams();
  const [dataSocket, setDataSocket] = useState(false);

  const validateSocketData = () => {
    let data = false;
    if (auctionId.toString() === id.toString()) {
      data = true;
    }
    return setDataSocket(data);
  };

  useEffect(() => {
    if (auctionId !== undefined) {
      validateSocketData();
    }
  }, [auctionId]);

  useEffect(() => {
    scrollEvent();
  }, []);

  const thousands = (num) => {
    return num.toString().split('').reverse().join('')
      .replace(/(?=\d*\.?)(\d{3})/g, '$1,')
      .split('')
      .reverse()
      .join('')
      .replace(/^[,]/, '');
  };

  return (
    <>
      <div className="bg-alabaster pt-5 p-sm-3 pb-30 d-block d-sm-none sticky-resumen-mobile">
        <div className="wrap">
          <button
            type="button"
            className="header bg-alabaster d-flex justify-content-between btn-link text-left"
            onClick={handleToogle}>
            <div className="title opacity-70 ml-2">
              <h2 className="">¡Has ofertado con éxito!</h2>
            </div>
            <div className="icon-title font-weight-bold text-tangaroa">
              {selected ? (<i className="fas fa-minus" />) : (<i className="fas fa-plus" />)}
            </div>
          </button>

          {selected && (
            <div className="content bg-alabaster text-center">
              <img src={successOffer} alt="exito" />
              <h5 className="text-tangaroa mb-30">{`${thousands(offer)} Puntos ofertados`}</h5>
              <p className="text-tangaroa">
                Hemos enviado un correo de confirmación de tu puja a
                <span className="font-weight-bold ml-1">{mail}</span>
              </p>
              <p className="text-tangaroa">
                Los Puntos Aeroméxico Rewards solo se descontarán
                de la cuenta del Socio ganador.
              </p>
              <button type="button" className="btn btn-primary my-30 w-100" id="sbs-dsb-dgr-btn-mor" onClick={handleOfferAgain}>Ofertar de nuevo</button>
            </div>
          )}
        </div>
      </div>

      <div className="mb-30 d-none d-sm-block font-weight-bold">
        Finaliza en:
        <CountDown
          closeDate={closeDate}
          todayDate={serverDate} />
      </div>
      <div className="text-center bg-alabaster p-3 pt-30 pt-sm-5 ht-1053">

        <div className="d-none d-sm-block">
          <h2 className="">¡Has ofertado con éxito!</h2>
          <img src={successOffer} alt="exito" />
          <h5 className="text-tangaroa mb-30">{`${thousands(offer)} Puntos ofertados`}</h5>
          <p className="text-tangaroa">
            Hemos enviado un correo de confirmación de tu puja a
            <span className="font-weight-bold ml-1">{mail}</span>
          </p>
          <p className="text-tangaroa">Los Puntos Aeroméxico Rewards solo se descontarán de la cuenta del Socio ganador.</p>

          <button type="button" className="btn btn-primary my-30 w-100" id="sbs-dsb-dgr-btn-mor" onClick={handleOfferAgain}>Ofertar de nuevo</button>
        </div>

        <div className="d-none d-sm-block">
          <hr className="pl-2 pr-2" />

          <div className={offers.length > 8 ? 'max-offer' : ''}>
            <h3 className="text-left mt-30">Últimas ofertas</h3>
            {dataSocket ? (
              allOffers.map((o) => (
                <ItemPeopleOffer
                  offer={o.offer}
                  person={o.personName}
                  type="Open" />
              ))
            ) : (
              offers.map((o) => (
                <ItemPeopleOffer
                  offer={o.offer}
                  person={o.personName}
                  type="Open" />
              ))
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default ItemSuccess;
